import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import theme from "./styles/theme";
import "./styles/global.css";
import Home from "./pages/home/Home";
import { HomeContent } from "./HomeContent";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState("Dashboard");

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");

    if (token && userData) {
      // Optional: Add token validation check here
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userName");
    window.history.pushState(null, "", "/dashboard");
    setSelected("Dashboard");
  };

  if (loading) {
    return <div>Loading...</div>; // Add loading state
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        {isAuthenticated ? (
          <HomeContent
            selected={selected}
            setSelected={setSelected}
            user={user}
            onLogout={handleLogout}
          />
        ) : (
          <Home onLogin={handleLogin} />
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
